import { useLocation } from 'react-router-dom'
import { docsNavigation, troubleshootNavigation } from '@/lib/navigation'

/**
 * Returns the sidebar navigation items for the current route.
 *
 * /sdk/* pages intentionally use docsNavigation so the API Reference
 * section expands in-place without replacing the sidebar.
 */
export function useNavigationItems() {
  const { pathname } = useLocation()

  if (pathname.startsWith('/troubleshoot')) {
    return troubleshootNavigation
  }

  return docsNavigation
}
